import { Shell } from "@/components/layout/Shell";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useLocation } from "wouter";
import { useRemontaLaudos } from "@/hooks/use-data";
import { LAUDO_STATUS_COLORS, LAUDO_STATUS_LABELS } from "@/lib/constants";
import { Loader2 } from "lucide-react";

export default function RevisaoTecnica() {
  const [, navigate] = useLocation();
  const { data: laudos = [], isLoading } = useRemontaLaudos({ status: "em_auditoria" });

  return (
    <Shell>
      <div className="space-y-6">
        <h1 className="text-2xl font-bold">Revisão Técnica</h1>
        <p className="text-sm text-slate-500">
          Laudos de Reclassificação aguardando aprovação ou devolução.
        </p>
        <Card>
          <CardContent className="pt-4">
            {isLoading ? (
              <div className="flex justify-center py-8">
                <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
              </div>
            ) : laudos.length === 0 ? (
              <p className="text-sm text-slate-500 py-8 text-center">
                Nenhum laudo pendente de auditoria.
              </p>
            ) : (
              <div className="space-y-2">
                {laudos.map((laudo: any) => (
                  <button
                    key={laudo.id}
                    onClick={() => navigate(`/laudos/${laudo.id}`)}
                    className="w-full flex items-center justify-between rounded-lg border border-slate-200 p-3 text-left hover:bg-slate-50"
                  >
                    <div>
                      <p className="font-medium">
                        {laudo.codigo ?? `Laudo #${laudo.id.slice(0, 8)}`}
                      </p>
                      <p className="text-sm text-slate-500">
                        {laudo.veiculo?.placa ?? "Veículo não identificado"}
                      </p>
                    </div>
                    <Badge className={LAUDO_STATUS_COLORS[laudo.status] ?? "bg-slate-100 text-slate-700"}>
                      {LAUDO_STATUS_LABELS[laudo.status] ?? laudo.status}
                    </Badge>
                  </button>
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </Shell>
  );
}
